import { render } from "./ModuleTools.vue?vue&type=template&id=4227415a"
import script from "./ModuleTools.vue?vue&type=script&lang=js"
export * from "./ModuleTools.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__